import { DeleteIdListObject, IdListObject } from "../components/grid/GridUtilities";
import sharedUtils from "../components/grid/sharedUtilities";

type NullableDate = Date | null | undefined;
export interface gridFilter {
    serviceType: string;
    dateFrom: NullableDate;
    dateTo: NullableDate;
}

export interface buttonState {
    amendIdValues: number[];
    approveIdValues: IdListObject;
    raiseQueryIdValues: number[];
    deleteIdValues: DeleteIdListObject;
}

export interface buttonClickable {
    isApproveValues: boolean;
    isDeleteValues: boolean;
}

const calculateDefaultDate = (isFromDate: boolean): NullableDate => {
    let returnDate: NullableDate;
    let utils = new sharedUtils();
    if (isFromDate) {
        returnDate = utils.fetchMinValueOfCurrentWeek();
    } else {
        returnDate = utils.fetchMaxValueOfCurrentWeek();
    }

    return returnDate;
};

const ManageShiftGlobalFilterService = (function () {
    // const [serviceValue, setService] = useState("");
    // const [dateFromValue, setDateFrom] = useState(undefined);
    // const [dateToValue, setDateTo] = useState(undefined);
    // const prevServiceType = previousValue(serviceValue);
    // const prevDateFrom = previousValue(dateFromValue);
    // const previousDateTo = previousValue(dateToValue);

    // function previousValue(value: any) {
    //     const ref = useRef();
    //     useEffect(() => {
    //         ref.current = value;
    //     });
    //     return ref.current;
    // }
    //  SET DEFAULT VALUES
    var currentFilterValues: gridFilter = {
        serviceType: "",
        dateFrom: calculateDefaultDate(true),
        dateTo: calculateDefaultDate(false),
    };
    var buttonStatesValues: buttonState = {
        amendIdValues: [],
        approveIdValues: {
            approvableBillableIdList: [],
            notaApprovableBillableIdList: [],
        },
        raiseQueryIdValues: [],
        deleteIdValues: {
            deletableIdList: [],
            notdeletableIdList: [],
        },
    };
    var buttonClickableOrNot: buttonClickable = {
        isApproveValues: true,
        isDeleteValues: true,
    };

    //
    const getFilterValues = function (): gridFilter {
        return {
            serviceType: currentFilterValues.serviceType,
            dateFrom: currentFilterValues.dateFrom,
            dateTo: currentFilterValues.dateTo,
        };
    };

    //
    const setServiceType = function (serviceFilterType: string) {
        // Set new service type filter
        currentFilterValues.serviceType = serviceFilterType;
        // Use default dates
        currentFilterValues.dateFrom = calculateDefaultDate(true);
        currentFilterValues.dateTo = calculateDefaultDate(false);
    };

    //
    const setFilterValues = function (dateFrom: NullableDate, dateTo: NullableDate): void {
        // Set new service type filter
        //currentFilterValues.serviceType = serviceFilterType;
        // Use dates provided
        currentFilterValues.serviceType = "";
        currentFilterValues.dateFrom = dateFrom;
        currentFilterValues.dateTo = dateTo;
    };

    // Set datefrom and dateto from Query String (D365)
    const setDateFromValue = function (dateFrom: NullableDate): void {
        currentFilterValues.dateFrom = dateFrom;
    };
    const setDateToValue = function (dateTo: NullableDate): void {
        currentFilterValues.dateTo = dateTo;
    };

    const IsUpdateRequired = function (preValue: gridFilter) {
        let utils = new sharedUtils();
        if (
            currentFilterValues.serviceType != preValue.serviceType ||
            utils.convertDateToString(currentFilterValues.dateFrom) != utils.convertDateToString(preValue.dateFrom) ||
            utils.convertDateToString(currentFilterValues.dateTo) != utils.convertDateToString(preValue.dateTo)
        ) {
            return true;
        } else {
            return false;
        }
    };
    const IsUpdateServiceType = function (preValue: gridFilter) {
        if (currentFilterValues.serviceType != preValue.serviceType) {
            return true;
        } else {
            return false;
        }
    };

    const setParentButtonStates = function (
        amendIdList: number[],
        approveIdList: IdListObject,
        enableRaiseQueryList: number[],
        enableDeleteList: DeleteIdListObject
    ) {
        buttonStatesValues.amendIdValues = amendIdList;
        buttonStatesValues.approveIdValues = approveIdList;
        buttonStatesValues.raiseQueryIdValues = enableRaiseQueryList;
        buttonStatesValues.deleteIdValues = enableDeleteList;
        setButtonClickableState();
    };

    const setButtonClickableState = function () {
        if (
            buttonStatesValues.approveIdValues.approvableBillableIdList.length != 0 &&
            buttonStatesValues.approveIdValues.notaApprovableBillableIdList.length == 0
        ) {
            buttonClickableOrNot.isApproveValues = false;
        } else if (buttonStatesValues.approveIdValues.notaApprovableBillableIdList.length != 0) {
            buttonClickableOrNot.isApproveValues = true;
        } else {
            buttonClickableOrNot.isApproveValues = true;
        }
        if (
            buttonStatesValues.deleteIdValues.deletableIdList.length != 0 &&
            buttonStatesValues.deleteIdValues.notdeletableIdList.length == 0
        ) {
            buttonClickableOrNot.isDeleteValues = false;
        } else if (buttonStatesValues.deleteIdValues.notdeletableIdList.length != 0) {
            buttonClickableOrNot.isDeleteValues = true;
        } else {
            buttonClickableOrNot.isDeleteValues = true;
        }
    };
    const getButtonClickableState = function () {
        return buttonClickableOrNot;
    };

    const getButtonStates = function () {
        return buttonStatesValues;
    };

    return {
        getFilterValues: getFilterValues,
        setServiceType: setServiceType,
        setFilterValues: setFilterValues,
        IsUpdateRequired: IsUpdateRequired,
        setDateFromValue: setDateFromValue,
        setDateToValue: setDateToValue,
        IsUpdateServiceType: IsUpdateServiceType,
        setParentButtonStates: setParentButtonStates,
        getButtonStates: getButtonStates,
        setButtonClickableState: setButtonClickableState,
        getButtonClickableState: getButtonClickableState,
    };
})();

export default ManageShiftGlobalFilterService;
